<template>
  <manageOrgchart/>
</template>

<script>
import manageOrgchart from '@/components/_managestructure/manageOrgchart.vue'
export default {
  components: {
    manageOrgchart
  }
}
</script>
